import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { redirectToLogin } from '@codespeak11/cognito-passwordless';
import { useAuth } from '../auth';

export default function Login() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return null;
  }

  return (
    <Box>
      <Box
        component="img"
        src="/images/BannerLogo.png"
        alt="Persona Fabricator"
        sx={{ height: 117, width: 'auto', borderRadius: 1 }}
      />
      <Typography variant="h5" fontWeight={600} textAlign="center" mb={1}>
        Welcome to the Persona Fabricator!
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center" mb={3}>
        Sign in with your BrainDance account to continue.
      </Typography>
      <Button
        variant="contained"
        fullWidth
        size="large"
        onClick={() => redirectToLogin()}
      >
        Sign In with BrainDance
      </Button>
    </Box>
  );
}
